const getWishListKey = () => {
  const jwt = localStorage.getItem("jwt");

  if (!jwt) return "wishList_guest";

  try {
    const userId = JSON.parse(jwt).user._id;
    return `wishList_${userId}`;
  } catch (e) {
    return "wishList_guest";
  }
};

export const isWish = (id, wList) => {
  const key = getWishListKey();
  const list = localStorage.getItem(key)
    ? JSON.parse(localStorage.getItem(key))
    : [];

  return list.includes(id);
};

export const isWishReq = (e, id, setWlist) => {
  const key = getWishListKey();

  let list = localStorage.getItem(key)
    ? JSON.parse(localStorage.getItem(key))
    : [];

  if (!list.includes(id)) {
    list.push(id);
    localStorage.setItem(key, JSON.stringify(list));
    setWlist(list);
  }
};

export const unWishReq = (e, id, setWlist) => {
  const key = getWishListKey();

  let list = localStorage.getItem(key)
    ? JSON.parse(localStorage.getItem(key))
    : [];

  if (list.includes(id)) {
    list.splice(list.indexOf(id), 1);
    localStorage.setItem(key, JSON.stringify(list));
    setWlist(list);
  }
};

export const nextSlide = (totalImg, slide, setSlide) => {
  if (slide === totalImg - 1) {
    setSlide(0);
  } else if (slide < totalImg) {
    setSlide(slide + 1);
  }
};

export const prevSlide = (totalImg, slide, setSlide) => {
  if (slide === 0) {
    setSlide(totalImg - 1);
  } else if (slide === totalImg - 1) {
    setSlide(0);
  }
};